<template>
    <div class="page-signup-await">
        <div class="block-title">Регистрация прошла успешно</div>
        <div class="text">
            Вы успешно зарегистрировались. На ваш email отправлено письмо с ссылкой на подтверждение регистрации.
            Проверьте почту
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.page-signup-await {
    .text {
        letter-spacing: 0.005em;
    }
}
</style>
